import api from "./api";

export const getCostPrices = () => api.get("/cost-prices");
export const createCostPrice = (data) => api.post("/cost-prices", data);
export const updateCostPrice = (id, data) => api.put(`/cost-prices/${id}`, data);
export const deleteCostPrice = (id) => api.delete(`/cost-prices/${id}`);